import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getServerEndpoint } from '../../utils/utils';


// handle requests to send us an email
export const submitEmail = createAsyncThunk('api/email', async (emailFormData, { rejectWithValue }) => {
	const url = `${getServerEndpoint()}/email`;
	try {
    const response = await fetch( url, { 
      method: "POST",
      headers: { "Content-Type": "application/json" }, 
  		body: JSON.stringify(emailFormData), 
    });
    if (!response.ok) throw new Error("Failed to send");
    return await response.json();
  } catch (error) {
    return rejectWithValue(error.message);
  }
});

export const confirmSignup = createAsyncThunk('api/confirmSignup', async (email, { rejectWithValue }) => {
	const url = `${getServerEndpoint()}/confirmSignup`;
	try {
    const response = await fetch( url, { 
      method: "POST",
      headers: { "Content-Type": "application/json" }, 
  		body: JSON.stringify(email), 
    });
    if (!response.ok) throw new Error("Failed to send");
    return await response.json();
  } catch (error) {
    return rejectWithValue(error.message);
  }
});

// handle requests to join the email list
export const submitJoinRequest = createAsyncThunk('api/join', async (emailSignupData, { rejectWithValue }) => {
	const url = `${getServerEndpoint()}/join`;
	try {
    const response = await fetch( url, { 
      method: "POST",
      headers: { "Content-Type": "application/json" }, 
  		body: JSON.stringify(emailSignupData), 
    });
    if (!response.ok) throw new Error("Failed to send");
    return await response.json();
  } catch (error) {
    return rejectWithValue(error.message);
  }
});

const emailSlice = createSlice({
  name: "email",
  initialState: { user: null, loading: false },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(submitEmail.fulfilled, (state, action) => {
        state.user = action.payload;
      })
      .addCase(submitEmail.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { logout } = emailSlice.actions;
export default emailSlice.reducer;